import LegalPage from './LegalPage';
import { COMPANY } from './legalConstants';

export default function Cookies() {
  return (
    <LegalPage title="Cookiebeleid" testId="legal-page-cookies">
      <p>
        Op <strong>{COMPANY.tradeName}</strong> gebruiken wij uitsluitend
        functionele cookies en lokale opslag die strikt noodzakelijk
        zijn voor de werking van de webshop. Er worden{' '}
        <strong>geen analytics-, tracking- of marketingcookies</strong>{' '}
        geplaatst zolang u daar niet uitdrukkelijk en voorafgaand
        toestemming voor heeft gegeven.
      </p>

      <h2>1. Wat zijn cookies?</h2>
      <p>
        Cookies zijn kleine tekstbestanden die door uw browser worden
        opgeslagen wanneer u een website bezoekt. Lokale opslag
        (localStorage / sessionStorage) is een gelijkaardige techniek
        in uw browser.
      </p>

      <h2>2. Welke functionele cookies en opslag gebruiken wij?</h2>
      <table className="text-sm border border-border my-4">
        <thead className="bg-muted/50">
          <tr>
            <th className="p-2 text-left">Naam</th>
            <th className="p-2 text-left">Type</th>
            <th className="p-2 text-left">Doel</th>
            <th className="p-2 text-left">Bewaartermijn</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-2 font-mono text-xs">cart_id</td>
            <td className="p-2">Cookie</td>
            <td className="p-2">Winkelmandje koppelen aan uw sessie</td>
            <td className="p-2">30 dagen</td>
          </tr>
          <tr>
            <td className="p-2 font-mono text-xs">auth</td>
            <td className="p-2">HttpOnly cookie</td>
            <td className="p-2">Aangemelde sessie behouden</td>
            <td className="p-2">Sessie</td>
          </tr>
          <tr>
            <td className="p-2 font-mono text-xs">herborist_locale</td>
            <td className="p-2">localStorage</td>
            <td className="p-2">Taalvoorkeur onthouden</td>
            <td className="p-2">Tot u die wijzigt</td>
          </tr>
          <tr>
            <td className="p-2 font-mono text-xs">email_confirm_*</td>
            <td className="p-2">sessionStorage</td>
            <td className="p-2">
              E-mailbevestigingsflow over paginaherlaad heen behouden
            </td>
            <td className="p-2">Sessie</td>
          </tr>
        </tbody>
      </table>

      <h2>3. Niet-essentiële cookies</h2>
      <p>
        Op dit moment gebruiken wij <strong>geen</strong> analytics-,
        statistiek- of marketingcookies. Indien deze in de toekomst
        worden ingezet, zal eerst een toestemmingsbanner worden
        getoond conform de Belgische ePrivacy-regels.
      </p>
      <p>
        <em>
          Interne nota — launch-blocker: PostHog analytics en
          sessieregistratie zijn uitgeschakeld in de pagina-loader
          tot een geldige opt-in via cookiebanner aanwezig is.
        </em>
      </p>

      <h2>4. Hoe cookies beheren?</h2>
      <p>
        U kan cookies steeds verwijderen of beperken via de
        instellingen van uw browser. Het uitschakelen van strikt
        noodzakelijke functionele cookies kan ertoe leiden dat
        bepaalde functies (zoals het winkelmandje of aangemeld
        blijven) niet meer correct werken.
      </p>

      <h2>5. Contact</h2>
      <p>
        Vragen over dit cookiebeleid kan u richten aan{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </p>
    </LegalPage>
  );
}
